export default {
    TITLE:'Upload Certificate of Incorporation',
    SUBTITLE:'Certificate of Incorporation',
    TOOLTIP:'Keep an eye on the Clara star for hints and tips.'
}